// @ts-nocheck
(function () {
  'use strict';

  // ── Config ────────────────────────────────────────────────────────────────
  const MAX_OFFSET_DEFAULT = 20;  // px — generic images (direct mode)
  const MAX_OFFSET_HERO = 20;  // px — custom .magnetic-hero section
  const MAX_OFFSET_HERO_PRO = 35;  // px — Magnetic Hero PRO (native hero clone)
  const MAX_OFFSET_PRO_TRIGGER = 25; // px — Magnetic Image & Text PRO
  const LERP_SPEED = 0.1; // lower = silkier

  /** Images inside these are never affected */
  const EXCLUDED_SELECTORS = [
    '.product-card',
    '.product-card__media',
    '.resource-card__media',
    '.card__media',
  ];

  /** Legacy banner selectors — images inside are skipped in direct mode */
  const LEGACY_BANNER_SELECTORS = [
    '.banner',
    '.hero',
    '.image-with-text__media',
    '[class*="banner"]',
    '[class*="hero"]',
  ];

  // ── State ─────────────────────────────────────────────────────────────────
  let states = [];
  const attached = new WeakSet(); // prevent duplicate listeners on re-init

  // ── Helpers ───────────────────────────────────────────────────────────────
  const isExcluded = (el) => EXCLUDED_SELECTORS.some((sel) => el.closest(sel));
  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

  // ── Event listener setup ──────────────────────────────────────────────────
  const setupListeners = (state) => {
    state.trigger.addEventListener('pointermove', (e) => {
      const rect = state.trigger.getBoundingClientRect();
      const nx = clamp((e.clientX - (rect.left + rect.width / 2)) / (rect.width / 2), -1, 1);
      const ny = clamp((e.clientY - (rect.top + rect.height / 2)) / (rect.height / 2), -1, 1);
      state.targetX = nx * state.offset;
      state.targetY = ny * state.offset;
    });
    state.trigger.addEventListener('pointerleave', () => {
      state.targetX = 0;
      state.targetY = 0;
    });
  };

  // ── Attach ────────────────────────────────────────────────────────────────
  const attach = (trigger, target, offset) => {
    if (!target || attached.has(trigger)) return;
    attached.add(trigger);
    const state = { trigger, target, offset, currentX: 0, currentY: 0, targetX: 0, targetY: 0 };
    states.push(state);
    setupListeners(state);
    target.style.willChange = 'transform';
  };

  // ── rAF loop ──────────────────────────────────────────────────────────────
  const animate = () => {
    for (const s of states) {
      s.currentX += (s.targetX - s.currentX) * LERP_SPEED;
      s.currentY += (s.targetY - s.currentY) * LERP_SPEED;
      s.target.style.transform = `translate3d(${s.currentX.toFixed(2)}px, ${s.currentY.toFixed(2)}px, 0)`;
    }
    requestAnimationFrame(animate);
  };

  // ── Init ──────────────────────────────────────────────────────────────────
  const startEngine = () => {
    states = []; // rebuild state list; WeakSet keeps listeners alive

    // Pass 0: Magnetic Hero PRO (.magnetic-hero-pro → .magnetic-hero-target) ──
    // Trigger = .magnetic-hero-pro (.hero root) — it IS interactive.
    // Target  = .magnetic-hero-target (.hero__media-wrapper) — pre-scaled 1.08
    //           via the <style> block injected in magnetic-hero.liquid.
    // The native .hero__media-wrapper has pointer-events:none in CSS, so we
    // cannot listen on it directly. We delegate from the .hero root.
    document.querySelectorAll('.magnetic-hero-pro').forEach((hero) => {
      if (isExcluded(hero)) return;
      const target = hero.querySelector('.magnetic-hero-target');
      if (!target) return;
      attach(hero, target, MAX_OFFSET_HERO_PRO);
    });

    // Pass 0b: Magnetic Image & Text PRO (.magnetic-pro-trigger → .magnetic-pro-target) ─
    // .magnetic-pro-trigger = .miwt__media (the overflow:hidden image wrapper).
    // .magnetic-pro-target  = the <img> inside it (pre-scaled 1.08 via CSS).
    // Only active when section.settings.hover_effect == 'magnetic' in Liquid.
    document.querySelectorAll('.magnetic-pro-trigger').forEach((trigger) => {
      if (isExcluded(trigger)) return;
      const target = trigger.querySelector('.magnetic-pro-target');
      if (!target) return;
      attach(trigger, target, MAX_OFFSET_PRO_TRIGGER);
    });

    // Pass 1: Custom .magnetic-hero sections ─────────────────────────────────
    document.querySelectorAll('.magnetic-hero').forEach((hero) => {
      if (isExcluded(hero)) return;
      const img = hero.querySelector('.magnetic-hero__img');
      if (!img) return;
      attach(hero, img, MAX_OFFSET_HERO);
    });

    // Pass 2: All other <img> tags (direct mode) ──────────────────────────────
    const legacySelector = LEGACY_BANNER_SELECTORS.join(',');
    document.querySelectorAll('img').forEach((img) => {
      if (isExcluded(img)) return;
      if (img.closest('.magnetic-hero-pro')) return;    // handled in Pass 0
      if (img.closest('.magnetic-pro-trigger')) return; // handled in Pass 0b
      if (img.closest('.magnetic-hero')) return;        // handled in Pass 1
      if (img.closest(legacySelector)) return;          // skip other legacy banners
      attach(img, img, MAX_OFFSET_DEFAULT);
    });
  };

  // ── Bootstrap ─────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startEngine);
  } else {
    startEngine();
  }
  requestAnimationFrame(animate);
  document.addEventListener('shopify:section:load', startEngine);
})();
